import { useApp } from "../context/AppContext";

export default function Marquee() {
  const { t } = useApp();
  const items = t.marquee;
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="border-y border-[var(--border)] bg-black py-6 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-4xl tracking-wide text-[var(--gold)]/85 px-8">
              {it}
            </span>
            <span className="text-[var(--gold)]/40 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
